import React, { useMemo } from 'react';
import { ResponsivePie } from '@nivo/pie';
import { i18nService } from '../../../../services/i18n.service';
import colors from '../../../../config/colors';

const Pie = ({ title, data, colorsObj, navigate, customKeys }: any) => {
	const computedData = useMemo(
		() =>
			data?.map((item: any) => ({
				id: i18nService.translate(`${title}.${item.key}`),
				label: i18nService.translate(`${title}.${item.key}`),
				value: item.val,
				color: colorsObj[item.key],
				key: customKeys ? customKeys[item.key] : item.key,
			})),
		[data, colorsObj, customKeys],
	);

	const getPadAngle = (data: any[]): number => {
		return data.filter((item: any) => item.value !== 0)?.length === 1
			? 0
			: 0.7;
	};

	const total = useMemo(
		() => computedData?.reduce((sum: number, item: any) => sum + item.value, 0) || 0,
		[computedData]
	);

	return (
		<ResponsivePie
			onClick={datum => {
				navigate({ status: [datum.data?.key] });
			}}
			theme={{
				fontFamily: 'RubikBold',
				fontSize: 14,
				tooltip: {
					container: {
						fontFamily: 'RubikRegular',
						fontSize: 14,
					},
				},
				legends: {
					text: {
						fontSize: 14,
						color: colors.darkGrey,
						fontFamily: 'RubikRegular',
					},
				},
			}}
			height={170}
			colors={datum => {
				return datum.data?.color;
			}}
			data={computedData || []}
			margin={{ top: 10, right: 10, bottom: 10, left: 400 }}
			innerRadius={0.7}
			padAngle={0}
			cornerRadius={0}
			activeOuterRadiusOffset={0}
			borderWidth={0}
			borderColor={{
				from: 'color',
				modifiers: [['darker', 0.2]],
			}}
			isInteractive={true}
			enableArcLinkLabels={false}
			arcLabelsSkipAngle={10}
			legends={[
				{
					anchor: 'left',
					direction: 'column',
					justify: false,
					translateX: -150,
					translateY: 0,
					itemsSpacing: 14,
					itemWidth: 100,
					itemHeight: 24,
					itemDirection: 'right-to-left',
					itemOpacity: 1,
					symbolSize: 10,
					symbolShape: 'circle',
					data: computedData?.map((item: any) => {
						const percentage = total > 0 ? ((item.value / total) * 100).toFixed(1) : 0;
						return {
							id: item.id,
							label: `${item.label}\u00A0\u00A0\u00A0\u00A0 ${percentage}%`,
							color: item.color,
						};
					})
				},
			]}
		/>
	);
};

export default Pie;
